export const parseAddress = addressComponents => {
  const companyAddress = [];
  let streetNumber = null;
  let streetAddress = null;
  let route = null;
  let city = '';
  let state = '';
  let postalCode = '';
  let country = '';

  addressComponents.forEach(component => {
    const { types, long_name: long, short_name: short } = component;

    if (types.includes('street_number')) {
      streetNumber = long;
    } else if (types.includes('street_address')) {
      streetAddress = long;
    } else if (types.includes('route')) {
      route = long;
    } else if (types.includes('locality')) {
      city = long;
    } else if (types.includes('administrative_area_level_1')) {
      state = short;
    } else if (types.includes('country')) {
      country = long;
    } else if (types.includes('postal_code')) {
      postalCode = long;
    }
  });

  if (streetNumber) {
    companyAddress.push(streetNumber);
  }

  if (streetAddress) {
    companyAddress.push(streetAddress);
  }

  if (route) {
    companyAddress.push(route);
  }

  return {
    companyAddress: companyAddress.join(' '),
    city,
    state,
    postalCode,
    country
  };
};
